import { InputMaybe, MiUser } from '@acre/graphql'
import { DropdownOption } from '@acre/design-system'

export const getFirmOptions = (
  organisationsWithUsers: {
    organisation_id?: string | null
    organisation_name?: string | null
    users?: InputMaybe<MiUser>[] | null
  }[],
) => {
  const filteredOrganisations = organisationsWithUsers?.filter((org) => org.organisation_id && org.organisation_name)

  return filteredOrganisations?.map((firm) => {
    return {
      label: firm.organisation_name,
      key: firm.organisation_id,
      value: firm.organisation_id,
    } as DropdownOption
  })
}

export const getAdvisorOptions = (users: InputMaybe<MiUser>[] | undefined | null) => {
  if (!users) return []

  const filteredUsers = users.filter((user) => user?.user_id && (user?.first_name || user?.last_name))

  return filteredUsers?.map((user) => {
    return {
      label: `${user?.first_name} ${user?.last_name}`.trim(),
      key: user?.user_id,
      value: user?.user_id,
    } as DropdownOption
  })
}
